import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=1d6b2a9e&scoped=true"
import script from "./noticeItem.vue?vue&type=script&lang=js"
export * from "./noticeItem.vue?vue&type=script&lang=js"
import style0 from "./noticeItem.vue?vue&type=style&index=0&id=1d6b2a9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b2a9e",
  null
  
)

export default component.exports